import Swiper, { Navigation, Thumbs } from 'swiper';
function initSwiperBanner() {
    const swiper = new Swiper('.mySwiper', {
        spaceBetween: 25,
        modules: [Navigation, Thumbs],
        slidesPerView: 3,
        watchSlidesProgress: true,
        breakpoints: {
            768: {
                slidesPerView: 'auto',
            },
        },
    });
    const swiper2 = new Swiper('.mySwiper2', {
        spaceBetween: 10,
        modules: [Navigation, Thumbs],
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        thumbs: {
            swiper,
        },
    });
}
function initSwiperOptional() {
    const optionsSleder = document.querySelectorAll('.js-init-sliders');
    optionsSleder &&
        optionsSleder.forEach((item) => {
            if (item instanceof HTMLElement) {
                const innitElements = item.querySelectorAll('.equipment-card');
                innitElements &&
                    innitElements.forEach((element, index) => {
                        if (element instanceof HTMLElement) {
                            const swiper = new Swiper(`.mySwiperOptional-${index}`, {
                                spaceBetween: 38,
                                modules: [Navigation, Thumbs],
                                slidesPerView: 'auto',
                                freeMode: true,
                                watchSlidesProgress: true,
                            });
                            const swiper2 = new Swiper(`.mySwiperOptional2-${index}`, {
                                spaceBetween: 10,
                                modules: [Navigation, Thumbs],
                                thumbs: {
                                    swiper,
                                },
                            });
                        }
                    });
            }
        });
}
const Sliders = { initSwiperBanner, initSwiperOptional };
export default Sliders;
